import {
  FETCH_DELIVERY_FEES_ERROR,
  FETCH_DELIVERY_FEES_START,
  FETCH_DELIVERY_FEES_SUCCESS
} from "./actionTypes";

const initialState = {
  loading: false,
  error: "",
  records: [],
  clearingCounter: 0,
  pagination: {},
  formLoading: false,
};
const deliveryFeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_FEES_START:
      state = {
        ...state,
        loading: true,
      };
      break;
    case FETCH_DELIVERY_FEES_SUCCESS:
      state = {
        ...state,
        loading: false,
        records: action.payload.docs,
        pagination: {
          ...action.payload,
        },
      };
      delete state.pagination.docs;
      break;
    case FETCH_DELIVERY_FEES_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
  }
  return state;
};
export default deliveryFeesReducer;
